module.exports = __webpack_public_path__ + "static/media/alan-logo.d4703a4b.svg";